import type { CSSProperties } from "react";
import styles from "./Skeleton.module.css";

interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  /** Aspect ratio (e.g. "3 / 4" for product images). Overrides height. */
  aspectRatio?: string;
  radius?: number | string;
  className?: string;
}

/** Shimmering placeholder for loading states. */
export function Skeleton({ width, height, aspectRatio, radius, className }: SkeletonProps) {
  const style: CSSProperties = {
    width: width ?? "100%",
    height: aspectRatio ? undefined : (height ?? 16),
    aspectRatio,
    borderRadius: radius ?? "var(--rb-radius-sm)",
  };
  return <div className={[styles.skeleton, className ?? ""].filter(Boolean).join(" ")} style={style} />;
}
